import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
export default (function (context) {
  return {
    namespaced: true,
    actions: {
      /**
       * @description 从持久化数据加载一系列的设置
       * @param {Object} vuex context
       */
      load: function load(_ref) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var dispatch;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  dispatch = _ref.dispatch;
                  _context.next = 3;
                  return dispatch('d2admin/user/load', undefined, {
                    root: true
                  });

                case 3:
                  _context.next = 5;
                  return dispatch('d2admin/theme/load', undefined, {
                    root: true
                  });

                case 5:
                  _context.next = 7;
                  return dispatch('d2admin/transition/load', undefined, {
                    root: true
                  });

                case 7:
                  _context.next = 9;
                  return dispatch('d2admin/page/openedLoad', undefined, {
                    root: true
                  });

                case 9:
                  _context.next = 11;
                  return dispatch('d2admin/menu/asideLoad', null, {
                    root: true
                  });

                case 11:
                  _context.next = 13;
                  return dispatch('d2admin/size/load', undefined, {
                    root: true
                  });

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    }
  };
});